<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">ثبت خرید</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/shop" />
      </div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <b-form-group
            v-show="hasPermission('write_created_at_in_mini_orders') ? true : false"
            class="col-md-6"
            label="زمان ثبت"
          >
            <date-picker
              type="datetime"
              v-model="created_at"
              :format="'YYYY-MM-DD HH:mm'"
              :display-format="'jYYYY-jMM-jDD HH:mm'"
            />
          </b-form-group>
          <b-form-group label="انتخاب مشتری">
            <div class="d-flex col-md-6 mb-3" style="gap: 0.5rem">
              <b-form-input
                @keypress.enter.prevent="requestCustomer"
                v-model="customerMobile"
                :disabled="disabled || customerInfo"
                @input="requestCustomer"
                type="text"
              />
              <button @click="clearCustomer" v-if="customerInfo" class="btn btn-danger">
                لغو مشتری
              </button>
            </div>
            <template v-if="customerInfo">
              <div v-if="customerInfo.customer" class="row">
                <div
                  v-for="i in [['حضوری', 'physical']]"
                  :key="i[1]"
                  class="col-6 d-flex justify-content-between px-3"
                >
                  <div>
                    شارژ کیف پول:
                    <span v-if="customerInfo.customer" class="font-weight-bold"
                      >{{ customerInfo.customer.wallet.balance | price }} تومان</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-12 font-weight-bold" v-else>مشتری جدید</div>
            </template>
          </b-form-group>
          <div class="row">
            <b-form-group class="col-md-6" label="نام">
              <b-form-input type="text" v-model="firstName" />
            </b-form-group>
            <b-form-group class="col-md-6" label="نام خانوادگی">
              <b-form-input type="text" v-model="lastName" />
            </b-form-group>
          </div>
          <b-form-group class="col-12" v-if="admin && !admin.store_id">
            <multiselect
              placeholder="انتخاب انبار"
              v-model="selectedStore"
              :options="stores"
              label="label"
              track-by="id"
              :searchable="true"
            >
              <template slot="noOptions">موردی یافت نشد</template>
              <template slot="noResult">موردی یافت نشد</template>
            </multiselect>
          </b-form-group>
          <b-form-group class="col-12">
            <label class="" for="products"> فروشنده <i class="text-danger">*</i></label>
            <div id="selectSeller">
              <button
                v-for="(seller, index) in sellers"
                :key="index"
                class="sellerBtn"
                :class="{ active: selectedSellerId == seller.id }"
                type="button"
                @click="selectedSellerFunc(seller)"
              >
                {{ seller.label }}
              </button>
            </div>
          </b-form-group>
          <b-form-group label="انتخاب محصول">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input
                autocomplete="off"
                autofocus
                ref="productSku"
                v-model="productSku"
                :disabled="disabled"
                @keypress.prevent.enter="requestProduct"
                type="text"
              />
              <div class="d-flex mr-3" style="gap: 0.6rem">
                <label for="refund_checkbox">مرجوعی</label>
                <b-form-checkbox
                  id="refund_checkbox"
                  type="checkbox"
                  :disabled="disabled"
                  v-model="refund"
                />
              </div>
            </div>
          </b-form-group>
          <b-form-group label="جستجوی محصول" class="mb-5">
            <ProductSearch
              ref="productSearch"
              :selectable="true"
              class="row mb-5"
              :store="admin.store_id"
              :show-label="false"
              @selectVariety="selectVariety"
            />
          </b-form-group>
          <div v-for="i in ['varieties', 'refund_varieties']" v-if="$data[i] != ''">
            <template>
              <h4 class="table-title">
                <template v-if="i === 'varieties'">فروش</template>
                <template v-else>مرجوع</template>
              </h4>
            </template>
            <span v-if="i === 'varieties'">
              {{ varieties.reduce((a, b) => a + b.quantity, 0) }}
            </span>
            <b-table
              class="mt-3 admin-order"
              :key="hasSelectedItem ? 'with-wallet' : 'without-wallet'"
              :class="$data[i]"
              hover
              bordered
              responsive
              :items="$data[i]"
              :fields="getFields(i)"
            >
              <template v-slot:cell(index)="data">
                <span :class="{ active: data.item.has_relation_with_category_9 }">
                  {{ data.index + 1 }}
                </span>
              </template>
              <template v-slot:cell(image)="data" class="text-center">
                <div class="order-product-img">
                  <a :href="getImage(data.item)">
                    <img class="w-100 h-100" :src="getImage(data.item)" />
                  </a>
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <span style="width: 300px">
                  <span style="line-height: 2">{{ data.item.product.title }}</span>
                  <span v-if="data.item.color || data.item.attributes != ''">
                    <span> | </span>
                    <span v-if="data.item.color">
                      رنگ : {{ data.item.color.name }}
                      {{ data.item.attributes != "" ? " | " : "" }}
                    </span>
                    <span v-if="data.item.attributes != ''">
                      <span v-for="(attr, index) in data.item.attributes" :key="index">
                        {{ attr.label + ": " + attr.pivot.value }}
                        {{ index != data.item.attributes.length - 1 ? " | " : "" }}
                      </span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-slot:cell(quantity)="data">
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="decrement(data.item)"
                  :disabled="data.item.quantity == 1 || disabled ? true : false"
                >
                  <DashSvg />
                </button>
                <span class="px-2">{{ data.item.quantity }}</span>
                <button
                  type="button"
                  class="border border-radius7 px-1 bg-none"
                  @click="increment(data.item)"
                  :disabled="disabled"
                >
                  <PlusSvg />
                </button>
              </template>
              <template v-slot:cell(amount)="data">
                <b-form-input
                  v-if="i !== 'varieties'"
                  style="width: 80px"
                  class="m-auto"
                  :value="data.item.price | priceinput"
                  @input="
                    (value) => {
                      data.item.price = value !== '' ? +value.replace(/\D/g, '') : '';
                    }
                  "
                >
                </b-form-input>
                <span v-else>
                  {{ data.item.price | price }}
                </span>
              </template>
              <template v-slot:cell(discount_amount)="data">
                <span
                  v-if="
                    data.item.final_price.discount_price && !editDiscount[data.item.id]
                  "
                >
                  {{ data.item.final_price.discount_price }}
                </span>
                <b-form-input
                  v-else
                  style="width: 80px"
                  class="m-auto"
                  :value="data.item.final_price.discount_price | priceinput"
                  @input="(value) => onDiscountInput(value, data.item)"
                >
                </b-form-input>
                <!-- <b-form-input  
                  v-else  
                  style="width: 80px"  
                  class="m-auto"  
                  :value="data.item.final_price.discount_price | priceinput"  
                  @input="(value) => onDiscountInput(value, data.item)"  
                >  
                </b-form-input>   -->
              </template>
              <template v-slot:cell(flash)="data">
                {{
                  data.item.product && data.item.product.active_flash != ""
                    ? data.item.product.active_flash[0].title
                    : "ندارد"
                }}
              </template>
              <template v-slot:cell(total_price)="data">
                <span v-if="data.item.final_price.amount != 0">
                  <!-- <span v-if="i !== 'varieties'">{{ (data.item.price * data.item.quantity) - (data.item.final_price.discount_price * data.item.quantity) | price }}</span> -->
                  <span v-if="i !== 'varieties'">
                    {{
                      data.item.selectedOrderItem
                        ? (data.item.selectedOrderItem.amount -
                            data.item.selectedOrderItem.spent_wallet) *
                          data.item.quantity
                        : data.item.final_price.discount_price > 0
                        ? data.item.price * data.item.quantity -
                          data.item.price *
                            data.item.quantity *
                            (data.item.final_price.discount_price / 100)
                        : (data.item.price * data.item.quantity) | price
                    }}
                  </span>
                  <span v-else>{{
                    (editDiscount[data.item.id]
                      ? data.item.final_price.amount * data.item.quantity -
                        data.item.final_price.amount *
                          data.item.quantity *
                          (data.item.final_price.discount_price / 100)
                      : data.item.final_price.amount * data.item.quantity) | price
                  }}</span>
                </span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(seller_id)="data">
                <b-button @click="sellerModalHandler(data.item.id)">
                  <span>
                    {{
                      seller_ids[data.item.id] && seller_ids[data.item.id].label
                        ? seller_ids[data.item.id].label
                        : "انتخاب نشده"
                    }}
                  </span>
                  <i class="fa fa-angle-down"></i>
                </b-button>
              </template>
              <template v-slot:cell(factor_id)="data">
                <div class="d-flex flex-column align-items-center">
                  <b-form-select
                    v-if="orderItems.length > 0"
                    v-model="currentOrderItem"
                    :options="[
                      {
                        text: 'فاکتور را انتخاب کنید',
                        value: null,
                        disabled: true,
                      },
                      ...orderItems.map((order) => ({
                        text:
                          'فاکتور شماره ' +
                          order.id +
                          ' | قیمت ' +
                          order.pos_amount.toLocaleString() +
                          ' تومن',
                        value: order,
                      })),
                    ]"
                    class="w-100 mb-2"
                  />
                  <b-form-select
                    v-if="
                      currentOrderItem && currentOrderItem.mini_order_items.length > 0
                    "
                    v-model="data.item.selectedOrderItem"
                    :options="[
                      {
                        text: 'آیتم را انتخاب کنید',
                        value: null,
                        disabled: true,
                      },
                      ...currentOrderItem.mini_order_items.map((item) => ({
                        text: item.variety_name,
                        value: item,
                      })),
                    ]"
                    class="w-100"
                  />
                </div>
              </template>
              <template v-slot:cell(wallet_used)="data">
                <span v-if="data.item.selectedOrderItem">
                  {{
                    (data.item.selectedOrderItem.spent_wallet * data.item.quantity)
                      | price
                  }}
                </span>
              </template>
              <template v-slot:cell(delete)="data">
                <a class="action-btns1 pt-1 px-2" @click="deleteItem(data.item, i)">
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </template>
            </b-table>
          </div>
          <template v-if="varieties != '' || refund_varieties != ''">
            <div
              class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex"
            >
              <div class="d-md-flex justify-content-around">
                <div class="d-flex">
                  <span class="py-2 font-bold"> فاکتور باز : </span>
                  <div class="px-3 py-2">
                    <input type="checkbox" v-model="isOpen" />
                  </div>
                </div>
                <div class="d-flex">
                  <span class="py-2 font-bold"> پرداخت با دیجی پی : </span>
                  <div class="px-3 py-2">
                    <input type="checkbox" v-model="isDigipay" />
                  </div>
                </div>
                <div class="d-flex">
                  <span class="py-2 font-bold"> پرداخت با اسنپ پی : </span>
                  <div class="px-3 py-2">
                    <input type="checkbox" v-model="isSnappay" />
                  </div>
                </div>
                <div class="d-flex">
                  <span class="py-2 font-bold"> استفاده از کیف پول : </span>
                  <div class="px-3 py-2">
                    <input type="checkbox" v-model="useWallet" />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-between">
              <div
                class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex"
              >
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> تخفیف(تومان) : </span>
                  <b-form-input
                    class="mt-1"
                    style="width: 130px"
                    :value="discountAmount | priceinput"
                    @input="onDiscountAmountInput"
                  />
                </div>

                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> مبلغ کارت به کارت (تومان): </span>
                  <b-form-input
                    class="mt-1"
                    style="width: 130px"
                    :value="cardByCard_amount | priceinput"
                    @input="
                      (value) => {
                        cardByCard_amount = value !== '' ? +value.replace(/\D/g, '') : '';
                      }
                    "
                  />
                </div>
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> مبلغ پرداخت نقدی (تومان): </span>
                  <b-form-input
                    class="mt-1"
                    style="width: 130px"
                    :value="cash_amount | priceinput"
                    @input="
                      (value) => {
                        cash_amount = value !== '' ? +value.replace(/\D/g, '') : '';
                      }
                    "
                  />
                </div>
                <div
                  v-if="
                    customerInfo &&
                    customerInfo.customer &&
                    customerInfo.customer.wallet &&
                    customerInfo.customer.wallet.balance > 0
                  "
                  class="d-md-flex justify-content-between"
                >
                  <span class="px-3 py-2 font-bold"> میزان کسر از کیف پول (تومان): </span>

                  <b-form-input
                    class="mt-1"
                    style="width: 130px"
                    :value="(totalRefunds > total ? 0 : walletB) | priceinput"
                    @input="
                      (value) => {
                        walletB = value !== '' ? +value.replace(/\D/g, '') : '';
                      }
                    "
                  />
                </div>

                <div class="d-md-flex justify-content-between" v-if="isSnappay">
                  <span class="px-3 py-2 font-bold"> مبلغ اسنپ پی (تومان): </span>
                  <b-form-input
                    class="mt-1"
                    style="width: 130px"
                    :value="snappayCashierAmount | priceinput"
                    @input="handleSnappayInput"
                  />
                </div>

                <div class="d-md-flex justify-content-between" v-if="isDigipay">
                  <span class="px-3 py-2 font-bold"> مبلغ دیجی پی (تومان): </span>
                  <b-form-input
                    class="mt-1"
                    style="width: 130px"
                    :value="digipayCashierAmount | priceinput"
                    @input="handleDigipayInput"
                  />
                </div>
                <div class="d-md-flex justify-content-between mt-1">
                  <span class="px-3 py-2 font-bold">دستگاه پوز: </span>
                  <b-form-group style="width: 133px">
                    <multiselect
                      placeholder="انتخاب دستگاه پوز"
                      v-model="selectedPos"
                      open-direction="bottom"
                      :options="poses"
                      label="label"
                      track-by="id"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                      :disabled="disabled"
                    >
                      <template slot="noOptions"> موردی یافت نشد </template>
                      <template slot="noResult"> موردی یافت نشد </template>
                    </multiselect>
                  </b-form-group>
                </div>
              </div>
              <div
                class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex"
              >
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> مجموع قیمت کالا ها : </span>
                  <span class="px-3 py-2"> {{ total | price }} تومان </span>
                </div>
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> مجموع قیمت مرجوعی ها : </span>
                  <span class="px-3 py-2"> {{ totalRefunds | price }} تومان</span>
                </div>
                <div v-if="hasSelectedItem" class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold">
                    مجموع مبلغ مرجوعی استفاده شده از کیف پول :
                  </span>
                  <span class="px-3 py-2">
                    {{
                      refund_varieties.reduce((sum, item) => {
                        return (
                          sum +
                          (item.selectedOrderItem
                            ? item.selectedOrderItem.spent_wallet * item.quantity
                            : 0)
                        );
                      }, 0) | price
                    }}
                    تومان
                  </span>
                </div>
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> جمع تخفیفات : </span>
                  <!-- <span class="px-3 py-2">  
                    {{ varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                      +
                      refund_varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                    | price }} تومان  
                  </span>   -->
                  <span class="px-3 py-2"> {{ totalDiscounts | price }} تومان </span>
                  <!-- <span class="px-3 py-2">  
                    {{ varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                      +
                      refund_varieties.reduce((total, variety) => total + variety.final_price.discount_price * variety.quantity, 0)
                    | price }}   
                  </span>   -->
                </div>
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold">مبلغ بازگشتی به مشتری:</span>
                  <span class="px-3 py-2 text-danger">
                    {{ (finalRefundPrice * 10) | price }} ریال
                  </span>
                </div>
                <div class="d-md-flex justify-content-between">
                  <span class="px-3 py-2 font-bold"> پرداخت از پوز (ریال): </span>
                  <span
                    class="px-3 py-2"
                    :class="{
                      'text-success': totalPrice >= 0,
                      'text-danger': totalPrice < 0,
                    }"
                  >
                    {{ (totalPrice * 10) | price }} ریال
                  </span>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <b-form-group class="col-md-6" label="یادداشت" :label-for="'description'">
                <b-form-textarea
                  id="description"
                  v-model="description"
                  placeholder="یادداشت"
                  :required="isDiscountFilled"
                />
              </b-form-group>
            </div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button
                type="button"
                @click="submitPos"
                :class="{ reqDiasableStyle: disablePos }"
                class="btn btn-success ml-2"
              >
                ارسال به پز
              </button>
              <button
                type="submit"
                :disabled="DiasableSubmit"
                :class="{ reqDiasableStyle: DiasableSubmit }"
                class="btn btn-success"
              >
                ثبت سفارش
              </button>
            </div>
          </template>
        </form>
      </div>
      <div id="selectSellerModal" @click="closeModal" v-if="showModal">
        <div id="selectSellerModalContainer">
          <div class="card">
            <div class="card-header border-0">
              <h5 class="card-title font-bold py-3">انتخاب فروشنده</h5>
              <div style="flex: 1"></div>
              <b-button variant="danger" @click="closeModal('close')">X</b-button>
            </div>
            <div class="card-body">
              <div id="selectSeller">
                <button
                  v-for="(seller, index) in sellers"
                  :key="index"
                  class="sellerBtn"
                  type="button"
                  @click="selectedSellerForVariety(seller)"
                >
                  {{ seller.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ShopCreate",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    BButton,
    Back,
    ProductSearch,
  },
  data() {
    return {
      disabled: false,
      disablePos: false,
      poses: false,
      refund: false,
      selectedSeller: null,
      selectedSellerId: null,
      selectedStore: null,
      selectedPos: null,
      seller_ids: {},
      showModal: false,
      created_at: null,
      editDiscount: {},
      discountAmount: 0,
      discountManuallyEdited: false,
      cardByCard_amount: null,
      digipayCashierAmount: "",
      snappayCashierAmount: "",
      cash_amount: null,
      currentOrderItem: null,
      isDigipay: false,
      isSnappay: false,
      description: null,
      sendCoupenStatus: false,
      sellers: [],
      isOpen: 0,
      useWallet: 1,
      selectedVarietyId: null,
      productSku: "",
      finalRefundPrice: 0,
      reqDiasableStyle: true,
      customerMobile: "",
      varieties: [],
      refund_varieties: [],
      stores: [],
      orderItems: [],
      poses: [],
      firstName: "",
      lastName: "",
      customerInfo: null,
      admin: null,
      flag: true,
      coupenPrice: null,
      hasSelectedItem: false,
      tableKey: 0,
      walletB: 0,
      coupen: null,
      disableCoupen: false,
      DiasableSubmit: false,
    };
  },
  computed: {
    isDiscountFilled() {
      if (this.totalPrice < 0 && this.cardByCard_amount <= 0 && this.cash_amount <= 0) {
        return true;
      } else {
        return false;
      }
    },
    storeId() {
      if (this.admin && this.admin.store_id) {
        return this.admin.store_id;
      }
      if (this.selectedStore) {
        return this.selectedStore.id;
      }
      return null;
    },
    isSellItem() {
      return this.varieties.length;
    },
    totalDiscounts() {
      let discountVarities = this.varieties.reduce((sum, item) => {
        const qty = Number(item.quantity) || 1;
        const price = Number(item.price) || 0;
        const percent = Number(item.final_price?.discount_price) || 0;

        const discount = Math.round(((price * percent) / 100) * qty);

        return sum + discount;
      }, 0);

      return discountVarities + (Number(this.discountAmount) || 0);
    },
    total() {
      const totalVarieties = this.varieties.reduce(
        (a, b) =>
          a +
          (b.price > 0
            ? b.price * b.quantity
            : b.final_price.amount + b.final_price.discount_price * b.quantity),
        0
      );

      return totalVarieties;
    },
    totalAfterItemDiscount() {
      return this.varieties.reduce((sum, item) => {
        const qty = Number(item.quantity) || 1;

        if (item.price > 0) {
          const price = Number(item.price) || 0;
          const percent = Number(item.final_price?.discount_price) || 0;
          const itemDiscount = Math.round(((price * percent) / 100) * qty);
          return sum + (price * qty - itemDiscount);
        } else {
          const amount = Number(item.final_price?.amount) || 0;
          return sum + amount * qty;
        }
      }, 0);
    },
    totalRefunds() {
      return this.refund_varieties.reduce((total, variety) => {
        const qty = variety.quantity || 0;
        const price = variety.price || 0;
        const amount = variety.selectedOrderItem ? variety.selectedOrderItem.amount : 0;
        const spent = variety.selectedOrderItem
          ? variety.selectedOrderItem.spent_wallet
          : 0;

        return total + (variety.selectedOrderItem ? amount - spent : price) * qty;
      }, 0);
    },
    totalPrice() {
      // --- Refund calculations ---
      const totalRefundAmount = this.refund_varieties.reduce((sum, item) => {
        const qty = Number(item.quantity) || 1;
        const final = Number(item.final_price?.amount) || 0;

        return (
          sum +
          (item.selectedOrderItem
            ? (this.isSellItem
                ? item.selectedOrderItem.amount
                : item.selectedOrderItem.amount - item.selectedOrderItem.spent_wallet) *
              qty
            : final * qty)
        );
      }, 0);

      const totalVarietiesAmount = this.varieties.reduce((sum, item) => {
        const qty = Number(item.quantity) || 1;
        const price = Number(item.price) || 0;
        return sum + price * qty;
      }, 0);

      const isRefundMoreThanSell = totalRefundAmount > totalVarietiesAmount;

      const adjustedRefundAmount = this.refund_varieties.reduce((sum, item) => {
        const qty = Number(item.quantity) || 1;
        const final = Number(item.final_price?.amount) || 0;

        return (
          sum +
          (item.selectedOrderItem
            ? (isRefundMoreThanSell
                ? item.selectedOrderItem.amount - item.selectedOrderItem.spent_wallet
                : this.isSellItem
                ? item.selectedOrderItem.amount
                : item.selectedOrderItem.amount - item.selectedOrderItem.spent_wallet) *
              qty
            : final * qty)
        );
      }, 0);

      let totalAmount = this.total;
      totalAmount -= adjustedRefundAmount;

      const totalDiscount = this.totalDiscounts;
      totalAmount -= totalDiscount;

      let walletBalance = this.customerInfo?.customer?.wallet?.balance || 0;
      if (this.walletB > walletBalance) this.walletB = 0;

      if (this.cardByCard_amount > 0) totalAmount -= this.cardByCard_amount;
      if (this.digipayCashierAmount > 0) totalAmount -= this.digipayCashierAmount;
      if (this.snappayCashierAmount > 0) totalAmount -= this.snappayCashierAmount;
      if (this.cash_amount > 0) totalAmount -= this.cash_amount;

      if (
        this.walletB > 0 &&
        Number(this.walletB) <= Number(totalAmount) &&
        this.useWallet
      ) {
        totalAmount -= this.walletB;
      } else if (this.walletB >= totalAmount && this.useWallet) {
        this.finalRefundPrice = totalAmount;
        totalAmount = 0;
      }

      return totalAmount;
    },
  },
  mounted() {
    this.listenForKeyPress();
    this.$nextTick(() => {
      const ms = this.$el.querySelector(".fix-multiselect .multiselect");
      if (ms) {
        const width = ms.getBoundingClientRect().width;
        document.documentElement.style.setProperty("--multiselect-width", `${width}px`);
      }
    });
  },
  methods: {
    handleDigipayInput(value) {
      this.digipayCashierAmount = value !== "" ? +value.replace(/\D/g, "") : "";
    },
    onDiscountAmountInput(value) {
      const num = value !== "" ? +value.replace(/\D/g, "") : 0;
      this.discountAmount = num;
      this.discountManuallyEdited = true;
    },
    getAutoDiscount(total) {
      // if (total >= 10000000) return 1000000;
      return 0;
    },
    handleSnappayInput(value) {
      this.snappayCashierAmount = value !== "" ? +value.replace(/\D/g, "") : "";
    },
    async requestCustomer(mobile) {
      if (mobile.length !== 11) return;
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/customer-search", {
          params: {
            mobile,
          },
        });
        this.disabled = false;
        const data = response.data.data;
        data.from_wallet_amount = data.from_wallet_amount || 0;
        this.customerInfo = data;
        this.walletB = this.customerInfo.customer?.wallet.balance;

        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      }
    },
    getFields(type) {
      const baseFields = [
        { key: "index", label: "ردیف" },
        { key: "barcode", label: "بارکد" },
        { key: "image", label: "تصویر" },
        { key: "title", label: "عنوان" },
        { key: "amount", label: "قیمت واحد (تومان)" },
        { key: "quantity", label: "تعداد" },
        { key: "discount_amount", label: "تخفیف واحد (درصد)" },
        { key: "seller_id", label: "فروشنده" },
        { key: "flash", label: "کمپین" },
        { key: "total_price", label: "قیمت نهایی (تومان)" },
        { key: "delete", label: "حذف" },
      ];

      if (type == "refund_varieties") {
        baseFields.splice(baseFields.length - 2, 0, {
          key: "factor_id",
          label: "فاکتور فروش",
        });
      }

      if (this.hasSelectedItem && type == "refund_varieties") {
        baseFields.splice(baseFields.length - 2, 0, {
          key: "wallet_used",
          label: "مبلغ استفاده شده از کیف پول",
        });
      }
      return baseFields;
    },
    async getData() {
      const responseAdmin = await this.$axios.get("admin/home");
      this.admin = responseAdmin.data.data.admin;

      const responseStore = await this.$axios.get("admin/stores");
      this.stores = responseStore.data.data.stores;

      const responsePos = await this.$axios.get("admin/admin-poses");
      this.poses = responsePos.data.data.admin.poses;

      if (this.admin && this.admin.store_id) {
        this.selectedStore = this.stores.find((s) => s.id === this.admin.store_id);
      }
      const responseSeller = await this.$axios.get(
        `admin/sellers?all=1&is_active=1&store_id=${this.admin.store_id}`
      );
      this.sellers = responseSeller.data.data.sellers.map((s) => {
        s.label = `${s.full_name}`;
        return s;
      });
      if (this.sellers.length == 1) {
        this.selectedSellerFunc(this.sellers[0]);
      }
    },
    checkCoupon() {
      if (this.coupenPrice) {
        this.coupenPrice = null;
        this.$root.notify("جهت محاسبه کد تخفیف آنرا مجددا وارد کنید", "warning");
      }
    },
    onDiscountInput(value, item) {
      item.final_price.discount_price = value !== "" ? +value.replace(/\D/g, "") : "";

      // item.final_price.amount = item.final_price.discount_price;
      this.$set(this.editDiscount, item.id, 1);
    },
    clearCoupon() {
      this.coupenPrice = null;
      this.coupen = "";
    },
    selectedSellerForVariety(seller) {
      this.seller_ids[this.selectedVarietyId] = {
        label: seller.label,
        id: seller.id,
      };
      this.closeModal("close");
    },
    selectVariety(variety) {
      console.log(variety, "variety");
      this.addVariety(variety);
    },
    async sendCoupen() {
      this.disableCoupen = true;
      const varieties = this.varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      const refund_varieties = this.refund_varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      try {
        let fd = new FormData();
        fd.append("code", this.coupen);
        let reqBody = {
          mobile: this.customerMobile,
          discount_amount: this.discountAmount,
          first_name: this.firstName,
          last_name: this.lastName,
          description: this.description,
          from_wallet_amount: this.from_wallet_amount,
          varieties,
          refund_varieties,
        };
        if (this.coupen) {
          reqBody.coupon_code = this.coupen;
        }
        const response = await this.$axios.post("admin/coupon/verify", reqBody);

        this.coupenPrice = response.data.data.discount.discount;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disableCoupen = false;
      }
    },
    listenForKeyPress() {
      document.removeEventListener("keyup", this.onKeyPress);
      document.addEventListener("keyup", this.onKeyPress);
    },
    onKeyPress(e) {},
    closeModal(e) {
      if (e == "close" || e.target.id == "selectSellerModal") {
        this.showModal = false;
      }
    },
    sellerModalHandler(id) {
      this.selectedVarietyId = id;
      this.showModal = true;
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            barcode: this.productSku,
            refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        if (this.coupenPrice) {
          this.coupenPrice = null;
          this.$root.notify("جهت محاسبه کد تخفیف آنرا مجددا وارد کنید", "warning");
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    addVariety(variety) {
      const mode = this.refund ? "refund_varieties" : "varieties";

      const alreadyAdded = this[mode].find((v) => v.id == variety.id);
      if (alreadyAdded) {
        alreadyAdded.quantity++;
        this.$root.notify("به تعداد محصول اضافه شد: " + alreadyAdded.quantity, "success");
        return;
      }

      const v = JSON.parse(JSON.stringify(variety));

      v.flat_discount = 0;
      v.factor_id = null;
      v.quantity = 1;

      v.price = Number(v.price) || 0;
      v.final_price = v.final_price || {};
      v.final_price.amount = Number(v.final_price.amount) || 0;
      v.final_price.discount_price = Number(v.final_price.discount_price) || 0;
      v.final_price.discount = Number(v.final_price.discount) || 0;

      if (v.final_price && v.final_price.discount_type === "flat") {
        v.flat_discount = v.final_price.discount_price || 0;
        const amount = v.price || v.final_price.amount || 0;
        const discountValue = Number(v.final_price.discount_price) || 0;
        if (amount > 0) {
          v.final_price.discount_price = parseFloat(
            ((discountValue / amount) * 100).toFixed(2)
          );
        } else {
          v.final_price.discount_price = 0;
        }
      } else if (v.final_price && v.final_price.discount_type === "percentage") {
        v.final_price.discount_price = v.final_price.discount || 0;
      }

      this.$set(v, "selectedOrderItem", null);
      this.$set(v, "factor_id", v.factor_id);
      console.log(v.flat_discount, "v.flat_discount");
      this.$set(v, "flat_discount", v.flat_discount);

      this[mode].push(v);
      if (this.customerInfo) {
        const isRefundItem = this.refund_varieties.length == 1 ? true : false;
        if (isRefundItem && mode == "refund_varieties") {
          this.$axios
            .get("admin/mini_orders-refund-search", {
              params: {
                mobile: this.customerInfo.customer.mobile,
              },
            })
            .then((res) => {
              this.orderItems = res.data.data.mini_orders;
              console.log(this.orderItems, "this.orderItems");
            });
        }
      }
      const calcTotalSellProducts = this.total - this.totalDiscounts;
      if (
        this.customerInfo &&
        this.customerInfo.customer?.wallet.balance >= calcTotalSellProducts &&
        !this.refund_varieties.length
      ) {
        this.walletB = calcTotalSellProducts;
      } else if (
        this.customerInfo &&
        this.walletB > this.refund_varieties.length &&
        this.totalPrice <= 0
      ) {
        this.walletB = 0;
      }
      if (this.customerInfo && this.walletB) {
        console.log(this.walletB, "this.walletB");
        // this.$set("walletB", this.walletB);
      }

      console.log(this.selectedSeller, "this.selectedSeller");

      this.seller_ids[v.id] = this.selectedSeller
        ? { label: this.selectedSeller.label, id: this.selectedSeller.id }
        : {};
    },
    selectedSellerFunc(seller) {
      console.log(seller, "sellerseller");

      this.selectedSellerId = seller.id;
      this.selectedSeller = seller;
    },
    getImage(variety) {
      if (variety.images != "") {
        return variety.images[0].url;
      }
      if (variety.product.images != "") {
        return variety.product.images[0].url;
      }
      return null;
    },
    decrement(variety) {
      if (variety.quantity === 0) {
        return;
      }
      variety.quantity--;
      this.checkCoupon();
    },
    increment(variety) {
      variety.quantity++;
      this.checkCoupon();
    },
    deleteItem(variety, mode) {
      this[mode] = this[mode].filter((v) => {
        return v.id !== variety.id;
      });
      this.checkCoupon();
    },
    clearCustomer() {
      this.customerInfo = null;
      this.walletB = 0;
      this.customerMobile = "";
    },
    async submitPos() {
      this.disablePos = true;
      let fd = new FormData();
      this.varieties.forEach((item, index) => {
        fd.append(`variety_ids[${index}]`, item.id);
      });
      fd.append(`pos_amount`, this.totalPrice);
      fd.append(
        "pos_id",
        this.selectedPos && this.selectedPos.id ? this.selectedPos.id : ""
      );
      try {
        const response = await this.$axios.post("admin/mini_orders/send-to-pos", fd);
        this.$root.notify(response?.data?.message, "success");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disablePos = false;
      }
    },
    async submit() {
      if (!this.validate()) {
        return;
      } else if (
        this.totalPrice < this.walletB &&
        this.customerInfo.customer.wallet.balance <= this.walletB &&
        !this.refund_varieties.length
      ) {
        console.log(
          this.totalPrice,
          this.walletB,
          "this.walletB",
          this.customerInfo.customer.wallet.balance
        );
        this.$root.notify("مبلغ کیف پول از قیمت فاکتور بیشتر میباشد.", "warning");
        return;
      } else if (
        this.refund_varieties.length &&
        this.walletB > 0 &&
        this.totalPrice &&
        this.totalPrice <= 0
      ) {
        this.$root.notify("مبلغ کیف پول در زمان مرجوعی قابل استفاده نیست.", "warning");
        return;
      } else if (
        this.isDigipay &&
        this.digipayCashierAmount &&
        this.digipayCashierAmount <= 0
      ) {
        this.$root.notify(
          "در صورت زدن تیک دیجی پی باید مبلغ پرداختی هم وارد کنید.",
          "warning"
        );
        return;
      }
      let fd = new FormData();
      if (this.created_at) {
        fd.append("created_at", this.created_at);
      }
      fd.append("cardByCard_amount", this.cardByCard_amount ? this.cardByCard_amount : 0);
      fd.append("store_id", this.storeId);
      fd.append("mobile", this.customerMobile);
      fd.append("first_name", this.firstName);
      fd.append("last_name", this.lastName);
      fd.append("cash_amount", this.cash_amount ? this.cash_amount : 0);
      fd.append("discount_amount", Number(this.discountAmount));
      fd.append("description", this.description);
      if (this.isDigipay) {
        fd.append(
          "digipay_cashier_amount",
          this.digipayCashierAmount ? this.digipayCashierAmount : 0
        );
        fd.append("is_digify_cashier", 1);
      }
      if (this.isSnappay) {
        fd.append(
          "snappay_cashier_amount",
          this.snappayCashierAmount ? this.snappayCashierAmount : 0
        );
        fd.append("is_snappay_cashier", 1);
      }
      if (this.walletB > 0 && this.useWallet) {
        fd.append("from_wallet_amount", this.walletB);
      } else {
        fd.append("from_wallet_amount", 0);
      }
      if (this.isOpen == true) {
        fd.append("is_open", 1);
      } else {
        fd.append("is_open", this.isOpen);
      }
      if (this.coupen) fd.append("coupon_code", this.coupen);
      fd.append("sendCouponIsActive", this.sendCoupenStatus ? 1 : 0);
      const totalDiscount = Number(this.discountAmount) || 0;

      let totalAmount = this.varieties.reduce((sum, item) => {
        return sum + Number(item.price) * Number(item.quantity);
      }, 0);

      if (totalAmount === 0) totalAmount = 1;

      this.varieties.forEach((item, index) => {
        const price = Number(item.price);
        const qty = Number(item.quantity);

        const itemDiscount =
          item.final_price.discount_price > 0
            ? price * (item.final_price.discount_price / 100)
            : 0;

        let finalDiscount = Math.round(itemDiscount);

        const finalAmount = this.rialRound(price - finalDiscount);

        if (this.varieties.length == 1) {
          finalDiscount = finalDiscount / qty;
        }

        fd.append(
          `varieties[${index}][seller_id]`,
          this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
        );

        fd.append(`varieties[${index}][id]`, item.id);
        fd.append(`varieties[${index}][quantity]`, qty);

        fd.append(`varieties[${index}][discount_amount]`, Math.round(finalDiscount));

        fd.append(`varieties[${index}][amount]`, finalAmount);
        fd.append(`varieties[${index}][real_amount]`, price);
      });

     this.refund_varieties.forEach((item, index) => {
  fd.append(
    `refund_varieties[${index}][seller_id]`,
    this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
  );
  fd.append(`refund_varieties[${index}][id]`, item.id);
  fd.append(`refund_varieties[${index}][quantity]`, item.quantity);

  if (item.selectedOrderItem && item.selectedOrderItem.id) {
    fd.append(
      `refund_varieties[${index}][refrence_mini_order_item_id]`,
      item.selectedOrderItem.id
    );
  }
  if (item.selectedOrderItem && item.selectedOrderItem.spent_wallet) {
    fd.append(
      `refund_varieties[${index}][charging_wallet]`,
      item.selectedOrderItem.spent_wallet
    );
  }

  let realAmount;
  let finalAmount;
  let discountAmount = 0;

  if (item.selectedOrderItem && item.selectedOrderItem.amount) {
    realAmount = item.selectedOrderItem.amount;
    finalAmount = item.selectedOrderItem.amount - item.selectedOrderItem.spent_wallet;
    discountAmount = 0;
  } else {
    realAmount = item.price;
    discountAmount =
      item.flat_discount > 0
        ? item.flat_discount
        : item.price * (item.final_price.discount_price / 100);
    finalAmount = this.rialRound(item.price - discountAmount);
  }

  fd.append(`refund_varieties[${index}][amount]`, finalAmount);
  fd.append(`refund_varieties[${index}][real_amount]`, realAmount);
  fd.append(`refund_varieties[${index}][discount_amount]`, Math.round(discountAmount));
});
      try {
        this.reqDiasableStyle = false;
        this.DiasableSubmit = true;

        this.disabled = true;

        const response = await this.$axios.post("admin/mini_orders", fd);

        const miniOrder = response.data.data.mini_order;
        this.$root.notify(response.data.message, "success");
        if (this.isDigipay) {
          this.$router.push(
            `/admin/shop/digipay/send-data/${miniOrder.id}?admin_id=${this.admin.id}&digipay_amount=${this.digipayCashierAmount}&store_id=${this.storeId}`
          );
        } else if (this.isSnappay) {
          this.$router.push(
            `/admin/shop/snappay/send-data/${miniOrder.id}?admin_id=${this.admin.id}&snappay_amount=${this.snappayCashierAmount}&store_id=${this.storeId}`
          );
        } else {
          this.$router.push(`/admin/shop/orders/${miniOrder.id}?print=1`);
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reqDiasableStyle = true;
        this.DiasableSubmit = false;
      }
    },
    rialRound(x) {
      return Math.round(x);
    },
    validate() {
      if (
        (!this.varieties || !this.varieties.length) &&
        !this.refund_varieties &&
        !this.refund_varieties.length
      ) {
        this.$root.warningNotify("حداقل انتخاب یک تنوع الزامی است");
        return false;
      }
      return true;
    },
  },
  watch: {
    isDigipay(newValue) {
      if (!newValue) {
        this.digipayCashierAmount = "";
        return;
      }

      if (this.isSnappay) {
        this.isDigipay = false;
        this.$root.notify(
          "در صورت زدن تیک اسنپ پی، امکان پرداخت با دیجی پی نیست.",
          "warning"
        );
        return;
      }

      this.digipayCashierAmount = this.totalPrice;
    },

    isSnappay(newValue) {
      if (!newValue) {
        this.snappayCashierAmount = "";
        return;
      }

      if (this.isDigipay) {
        this.isSnappay = false;
        this.$root.notify(
          "در صورت زدن تیک دیجی پی، امکان پرداخت با اسنپ پی نیست.",
          "warning"
        );
        return;
      }

      this.snappayCashierAmount = this.totalPrice;
    },
    useWallet(newValue) {
      if (newValue) {
        //this.walletB = this.customerInfo?.customer?.wallet.balance;
      } else {
        this.walletB = 0;
      }
    },
    refund_varieties: {
      handler(newVal) {
        console.log(newVal, "newVal");
        this.hasSelectedItem = !!(
          this.currentOrderItem && this.currentOrderItem.mini_order_items.length > 0
        );
      },
      deep: true,
    },
    currentOrderItem: {
      handler(newVal) {
        if (!newVal || !newVal.mini_order_items) return;

        newVal.mini_order_items = newVal.mini_order_items
          .filter((i) => i.type === "sell")
          .map((i) => {
            const baseSpent = i.original_spent_wallet ?? i.spent_wallet;

            const spentPerUnit =
              i.quantity > 1 ? Math.floor(baseSpent / i.quantity) : baseSpent;

            return {
              ...i,
              spent_wallet: spentPerUnit,
              original_spent_wallet: baseSpent,
            };
          });
      },
      deep: false,
    },
    discountAmount(newValue) {
      this.checkCoupon();
    },
    totalAfterItemDiscount(newVal) {
      if (newVal === 0) {
        this.discountManuallyEdited = false;
        this.discountAmount = 0;
        return;
      }
      if (this.discountManuallyEdited) return;
      this.discountAmount = this.getAutoDiscount(newVal);
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style scoped>
.table-responsive {
  height: auto;
}

.reqDiasableStyle {
  cursor: not-allowed;
  opacity: 0.5;
}

.order-product-img {
  max-width: 50px;
  margin: auto;
}

.table-title {
  font-weight: bold;
}
</style>
<style>
.admin-order table tr:has(span.active) {
  background: #007bff21;
}

.admin-order table tr:has(span.active):hover {
  background-color: #007bff21 !important;
  cursor: pointer;
}

.card.little.info {
  background: linear-gradient(30deg, #d2e8ff 0%, #d5e6fc 35%, #eaf5ff 100%);
}

.card.little.online {
  background: linear-gradient(30deg, #c8ffc8 0%, #c8ffc8 35%, #e0ffe0 100%);
}

.card.little.physical {
  background: linear-gradient(30deg, #ffffe3 0%, #ffffbc 35%, #ffffc5 100%);
}

.card.little .card-header {
  font-weight: bold;
}

form#coupenCode input[type="submit"] {
  background-color: #1d99ff;
  color: white;
}

form#coupenCode input {
  padding: 4px 8px;
  border: 2px solid #1d99ff;
}

.disableCoupen {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

button#sendCoupen {
  display: flex;
  align-items: center;
  gap: 8px;
}

button#sendCoupen input {
  transform: scale(1.5);
}

.btnprimary {
  color: #fff !important;
  background-color: #0075ff;
  border-color: #3366ff;
}

.btnprimary:hover {
  background-color: #0256b8;
}

.btnprimary:hover input[type="checkbox"] {
  accent-color: #0256b8;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(6, 2fr);
  gap: 12px;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(10, 4fr);
  gap: 8px;
}

.mt-3.admin-order.table-responsive.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store {
  overflow: visible;
}

div#selectSellerModal {
  position: fixed;
  inset: 0;
  background: #11221194;
  z-index: 10000;
}

div#selectSellerModalContainer {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
</style>
